import { render, staticRenderFns } from "./ClinicSchedule.vue?vue&type=template&id=5b967a92&scoped=true"
import script from "./ClinicSchedule.vue?vue&type=script&lang=js"
export * from "./ClinicSchedule.vue?vue&type=script&lang=js"
import style0 from "./ClinicSchedule.vue?vue&type=style&index=0&id=5b967a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b967a92",
  null
  
)

export default component.exports